import React from "react";
import { withStyles } from "@mui/styles";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { IconButton } from "@mui/material";

const styles: any = (): any => ({
  colorPrimary: {
    "& .MuiSvgIcon-root": {
      fill: "url(#selected)",
    },
  },
});

const IconLinkButton: any = withStyles(styles)(({
  children,
  to,
  classes,
  lookup,
  ...props
}: any) => {
  const { pathname = "" } = useLocation();
  const selected: boolean = pathname.includes(to) || pathname.includes(lookup);
  return (
    <IconButton
      classes={classes}
      size="large"
      color={selected ? "primary" : "inherit"}
      component={RouterLink}
      to={to}
      {...props}
    >
      {children}
    </IconButton>
  );
});
export default IconLinkButton;
